export enum SP3ZoneType {
  NO = 0x00,
  NC = 0x01,
  EOL = 0x02,
  EOL_T = 0x03,
  ATZ = 0x04,
  ATZ_T = 0x05,
  EOL3 = 0x06,
}
